import { render, staticRenderFns } from "./ToolHelp.vue?vue&type=template&id=b96e84f0"
import script from "./ToolHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolHelp.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports